import SODItem from './SODItem';

export default SODItem;
